import {Radio} from '@practicegenius/pg-ui/src/base/Material/components/Radio';
import React from 'react';

export enum InterestedPartyType {
  myself = 'myself',
  myChild = 'myChild',
}

type Props = {
  interestedParty: InterestedPartyType;
  langStrings: {
    [InterestedPartyType.myself]: string;
    [InterestedPartyType.myChild]: string;
  };
  onChange: React.ChangeEventHandler;
};

const labelProps: {style: React.CSSProperties} = {style: {fontWeight: 400}};

export const InterestedParty: React.FC<Props> = ({
  interestedParty,
  langStrings,
  onChange,
}) => {
  const isForChild = interestedParty === InterestedPartyType.myChild;
  return (
    <>
      <Radio
        name="interestedParty"
        value={InterestedPartyType.myself}
        checked={!isForChild}
        onChange={onChange}
        label={langStrings[InterestedPartyType.myself]}
        labelProps={labelProps}
      />
      <Radio
        name="interestedParty"
        value={InterestedPartyType.myChild}
        checked={isForChild}
        onChange={onChange}
        label={langStrings[InterestedPartyType.myChild]}
        labelProps={labelProps}
      />
    </>
  );
};
